import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Catalog from "./pages/Catalog";
import CourseDetail from "./pages/CourseDetail";
import MyCourses from "./pages/MyCourses";
import Webinars from "./pages/Webinars";
import Notifications from "./pages/Notifications";
import { TeacherCourses, NewCourse, EditCourse } from "./pages/Teacher";
import { AdminUsers, AdminCourses, AdminVideos, AdminWebinars } from "./pages/Admin";
import { NewWebinar, EditWebinar, WebinarDetail } from "./pages/WebinarPages";
import { BundlesCatalog, BundleDetail, AdminBundles } from "./pages/Bundles";
import AppLayout from "./components/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRouter() {
  const location = useLocation();
  // Google Auth callback: session_id lives in URL hash after redirect
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/catalog" element={<Protected><Catalog /></Protected>} />
      <Route path="/courses/:id" element={<Protected><CourseDetail /></Protected>} />
      <Route path="/my-courses" element={<Protected><MyCourses /></Protected>} />
      <Route path="/webinars" element={<Protected><Webinars /></Protected>} />
      <Route path="/webinars/:id" element={<Protected><WebinarDetail /></Protected>} />
      <Route path="/teacher/new-webinar" element={<Protected><NewWebinar /></Protected>} />
      <Route path="/teacher/webinars/:id/edit" element={<Protected><EditWebinar /></Protected>} />
      <Route path="/admin/webinars" element={<Protected><AdminWebinars /></Protected>} />
      <Route path="/bundles" element={<Protected><BundlesCatalog /></Protected>} />
      <Route path="/bundles/:id" element={<Protected><BundleDetail /></Protected>} />
      <Route path="/admin/bundles" element={<Protected><AdminBundles /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/teacher/courses" element={<Protected><TeacherCourses /></Protected>} />
      <Route path="/teacher/new-course" element={<Protected><NewCourse /></Protected>} />
      <Route path="/teacher/courses/:id/edit" element={<Protected><EditCourse /></Protected>} />
      <Route path="/admin/users" element={<Protected><AdminUsers /></Protected>} />
      <Route path="/admin/courses" element={<Protected><AdminCourses /></Protected>} />
      <Route path="/admin/videos" element={<Protected><AdminVideos /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
